import { InteractiveModelSvgProps } from './InteractiveModel.types'
import React, { useState } from 'react'

export const InteractiveModelSvg = ({
    imageData,
    polygonsData,
    devProject,
    handlePolygonClick,
    setHoveredPropertyId,
    lastHoveredProperty
}: InteractiveModelSvgProps) => {
    const [shineActive, setShineActive] = useState(true)

    const onPolygonMouseEnter = (polygonId: number) => {
        setHoveredPropertyId(polygonId)
        if (shineActive) {
            setShineActive(false)
        }
    }

    return (
        <svg
            className='absolute top-0 left-0 w-full h-full rounded-2xl'
            style={{ pointerEvents: 'none' }}
            preserveAspectRatio='xMidYMid meet'
            viewBox={`0 0 ${imageData.width} ${imageData.height}`}
        >
            <defs>
                <linearGradient id='shineGradient'>
                    <stop offset='0%' stopColor='transparent' />
                    <stop offset='50%' stopColor='rgba(255, 255, 255, 0.5)' />
                    <stop offset='100%' stopColor='transparent' />
                    <animate attributeName='x1' from='-100%' to='200%' dur='3s' repeatCount='indefinite' />
                    <animate attributeName='x2' from='0%' to='300%' dur='3s' repeatCount='indefinite' />
                </linearGradient>
            </defs>

            {polygonsData.map((polygon, index) => {
                const correspondingDevProject = devProject?.find(dp => dp.id === polygon.idPropertyMicrosite)

                let hoverClass = 'hover:fill-blue-500/50'
                let fillClass = 'fill-transparent'

                if (correspondingDevProject) {
                    switch (correspondingDevProject.state) {
                        case 0:
                            hoverClass = 'hover:fill-green-400/50'
                            fillClass = 'fill-green-400/50'
                            break
                        case 1:
                            hoverClass = 'hover:fill-yellow-500/50'
                            fillClass = 'fill-yellow-500/50'
                            break
                        case 2:
                            hoverClass = 'hover:fill-red-400/50'
                            fillClass = 'fill-red-400/50'
                            break
                        case 3:
                            hoverClass = 'hover:fill-blue-200/50'
                            fillClass = 'fill-blue-200/50'
                            break
                        case 4:
                            hoverClass = 'hover:fill-blue-700/50'
                            fillClass = 'fill-blue-700/50'
                            break
                    }
                }

                const finalFillClass =
                    lastHoveredProperty && polygon.idPropertyMicrosite === lastHoveredProperty.id
                        ? fillClass
                        : shineActive
                          ? 'url(#shineGradient)'
                          : 'fill-transparent'

                return (
                    <polygon
                        key={index}
                        id={polygon.id}
                        points={polygon.points}
                        onClick={() => handlePolygonClick(polygon.fileUrl, polygon.idPropertyMicrosite)}
                        onMouseEnter={() => onPolygonMouseEnter(polygon.idPropertyMicrosite)}
                        onMouseLeave={() => setHoveredPropertyId(null)}
                        className={`stroke-current text-transparent ${finalFillClass} ${hoverClass} cursor-pointer pointer-events-auto`}
                        fill={finalFillClass}
                    />
                )
            })}
        </svg>
    )
}
